import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './TheaterButton';
import { requestToggleTheaterView } from '../../../DeviationPage/redux/actions';
import { getIsTheaterForced } from '../../../DeviationPage/redux/selectors';

type StateProps = Pick<Props, 'isTheaterForced'>;

type DispatchProps = Pick<Props, 'onClick'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (
  state,
  { deviation }
) => ({
  isTheaterForced: getIsTheaterForced(state, deviation),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onClick: requestToggleTheaterView,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
